module.exports = __webpack_public_path__ + "static/media/modal.b82d23a6.svg";